import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './css/Alert.scss';
import classNames from 'classnames';

export default class Alert extends Component {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        small: PropTypes.bool,
        type: PropTypes.oneOf(['default', 'info', 'success', 'danger', 'warning', 'deactivateProfile']),
    }

    static defaultProps = {
        type: 'default',
        loading: false,
    }

    render() {
        const { type, small, className, children } = this.props;

        return (
            <div className={classNames(styles[type], small ? styles.small : null, className)}>
                {children}
            </div>
        );
    }
}
